export const style = {
  container: {
    sx: {
      pt: 2,
    },
  },
  divider: {
    mb: 3,
  },
  dialogContent: {
    row: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '15px 0px',
    },
  },
  inputLabel: {
    position: 'absolute',
    right: '0px',
    top: '15px',
    textAlign: 'end',
    width: '100%',
  },
  Typography: {
    sx: {
      '& .MuiInputLabel-root': {
        color: 'text.primary',
        fontWeight: 500,
      },
    },
  },
} as const;
